<template>
    <div class="main-container" id="anchor-images">
        <div
            class="hq-images-section">
            <h2>{{ $t("press.hqImagesSection.hq-images").toUpperCase() }}</h2>
            <div class="hq-images-grid">
                <div
                    v-for="(image, index) in images"
                    :key="index"
                    class="hq-images-cell">
                    <img
                        v-tilt
                        :src="image.src" />
                    <p>{{ image.description }}</p>
                    <div class="hq-images-download">
                        <p>{{ $t("press.hqImagesSection.download") }}</p>
                        <a
                            :href="image.download"
                            :download="image.download"
                            target="_blank">
                            {{
                                image.src.substr(image.src.lastIndexOf(".") + 1) == "gif"
                                    ? $t("press.hqImagesSection.gif")
                                    : $t("press.hqImagesSection.png")
                            }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DracolicheBanner from '@/static/img/PictureThumbnails/Dracoliche_Banner.png'
import Citywalls from '@/static/img/PictureThumbnails/Citywalls.png'
import Iceland from '@/static/img/PictureThumbnails/Iceland.png'
import SplashScreenGod from '@/static/img/PictureThumbnails/Splash_Screen_God.png'
import TheSandboxCharacters from '@/static/img/PictureThumbnails/The_Sandbox_Characters.png'
import TheSandboxCharacters2 from '@/static/img/PictureThumbnails/The_Sandbox_Characters_2.png'
import IslandsBackground from '@/static/img/PictureThumbnails/Islands_Background.png'
import DracolicheBanner2 from '@/static/img/PictureThumbnails/Dracoliche_Banner_2.png'
import ChestGif from '@/static/img/PictureThumbnails/Chest_Gif.jpg'
import splashScreenFocus from '@/static/img/PictureThumbnails/Splashscreen_focus.jpg'
import splashScreenGlobal from '@/static/img/PictureThumbnails/Splashscreen_global.jpg'
import splashScreenGlobal2 from '@/static/img/PictureThumbnails/Splashscreen_global2.jpg'

export default {
    computed: {
        translate () {
            return {
                imgDescription: [
                    this.$t('press.hqImagesSection.imgDescription1'),
                    this.$t('press.hqImagesSection.imgDescription2'),
                    this.$t('press.hqImagesSection.imgDescription3'),
                    this.$t('press.hqImagesSection.imgDescription4'),
                    this.$t('press.hqImagesSection.imgDescription5'),
                    this.$t('press.hqImagesSection.imgDescription6'),
                    this.$t('press.hqImagesSection.imgDescription7'),
                    this.$t('press.hqImagesSection.imgDescription8'),
                    this.$t('press.hqImagesSection.imgDescription9'),
                    this.$t('press.hqImagesSection.imgDescription10'),
                    this.$t('press.hqImagesSection.imgDescription11'),
                    this.$t('press.hqImagesSection.imgDescription12')
                ]
            }
        },
        imgPathHigh () {
            return 'https://presskit.sandbox.game/Picture/'
        },
        imgPathLow () {
            return 'https://presskit.sandbox.game/PictureThumbnails/'
        },
        images () {
            return [
                {
                    src: splashScreenFocus,
                    download: splashScreenFocus,
                    description: this.translate.imgDescription[9]
                },
                {
                    src: splashScreenGlobal,
                    download: splashScreenGlobal,
                    description: this.translate.imgDescription[10]
                },
                {
                    src: splashScreenGlobal2,
                    download: splashScreenGlobal2,
                    description: this.translate.imgDescription[11]
                },
                {
                    src: DracolicheBanner,
                    download: this.imgPathHigh + 'Dracoliche_Banner.png',
                    description: this.translate.imgDescription[0]
                },
                {
                    src: Citywalls,
                    download: this.imgPathHigh + 'Citywalls.png',
                    description: this.translate.imgDescription[1]
                },
                {
                    src: Iceland,
                    download: this.imgPathHigh + 'Iceland.png',
                    description: this.translate.imgDescription[2]
                },
                {
                    src: SplashScreenGod,
                    download: this.imgPathHigh + 'Splash_Screen_God.png',
                    description: this.translate.imgDescription[3]
                },
                {
                    src: TheSandboxCharacters,
                    download: this.imgPathHigh + 'The_Sandbox_Characters.png',
                    description: this.translate.imgDescription[4]
                },
                {
                    src: TheSandboxCharacters2,
                    download: this.imgPathHigh + 'The_Sandbox_Characters_2.png',
                    description: this.translate.imgDescription[5]
                },
                {
                    src: IslandsBackground,
                    download: this.imgPathHigh + 'Islands_Background.png',
                    description: this.translate.imgDescription[6]
                },
                {
                    src: DracolicheBanner2,
                    download: this.imgPathHigh + 'Dracoliche_Banner_2.png',
                    description: this.translate.imgDescription[7]
                },
                {
                    src: ChestGif,
                    download: this.imgPathHigh + 'Chest_Gif.gif',
                    description: this.translate.imgDescription[8]
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
  .main-container {
    padding: 100px 0px;
    background-color: $grey-15;
    @include breakpoint($device: mobile) {
        padding: 80px 0px;
    }
    a {
      text-decoration: none;
      color: $blue-2 !important;
      font-weight: 600;
    }
    p {
        margin-bottom: 0;
    }
    @include breakpoint($min: desktop-sm) {
      & > div:not(:first-child) {
        margin: auto;
        max-width: 75vw;
      }
    }
    .hq-images-section {
      @include flex(column, center, center);
      width: 100%;
      h2 {
        font-size: 50px;
        font-weight: Bold;
      }
      .hq-images-grid {
        display: grid;
        gap: 2em;
        grid-template-columns: repeat(3, minmax(300px, 1fr));
        margin-top: 3vh;
        min-width: 1050px;
        @include breakpoint($max: tablet) {
          min-width: auto;
          grid-template-columns: repeat(2, minmax(300px, 1fr));
        }
        @include breakpoint($max: mobile) {
          grid-template-columns: repeat(1, minmax(300px, 1fr));
        }
        & > div > img {
          width: 330px;
          border-radius: 10px;
        }
        & > div > p {
          margin-top: 15px;
          color: white;
          font-size: 22px;
          text-align: left;
          font-weight: 600;
          font-family: "Montserrat Bold", sans-serif;
        }
        .hq-images-cell {
          justify-self: center;
          align-self: center;
        }
        .hq-images-download {
          display: grid;
          grid-gap: 0.5em;
          grid-template-columns: repeat(3, minmax(50px, 1fr));
          margin-top: 5px;
          & > * {
            justify-self: start;
            align-self: center;
          }
          p {
            color: $gray11;
            font-size: 18px;
            font-weight: bold;
            font-family: "Montserrat Bold", sans-serif;
          }
          a {
            text-decoration: none;
            color: $blue-1;
            font-family: "Montserrat Bold", sans-serif;
          }
        }
      }
    }
  }
@include breakpoint($device: touch) {
  .main-container {
    scroll-behavior: smooth;
    .hq-images-section {
      @include flex(column, center, center);
      h2 {
        font-size: 25px;
        font-weight: Bold;
      }
      & > .hq-images-grid > .hq-images-cell:not(:first-child) {
        margin-top: 20px;
      }
      & > .hq-images-grid > .hq-images-cell > img {
        width: 330px;
        border-radius: 10px;
        &:not(:first-child) {
          margin-top: 20px;
        }
      }
      & > .hq-images-grid > .hq-images-cell > p {
        margin-top: 15px;
        color: white;
        font-size: 18px;
        font-family: "Montserrat Bold", sans-serif;
      }
      & > .hq-images-grid > .hq-images-cell > .hq-images-download {
        @include flex(row, center, flex-start);
        margin: 0;
        & > * {
          margin-top: 0px;
        }
        p {
          color: #a0a4a7;
          font-size: 18px;
          font-family: "Montserrat Bold", sans-serif;
        }
        a {
          margin-left: 22px;
          font-size: 14px;
          font-family: "Montserrat Bold", sans-serif;
          color: $blue-1;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
